import useTileRepository from "@/hooks/useTileRepository";
import GameError, { GameErrorType } from "@/libs/GameError";
import useSettlementsStore from "@/store/useSettlementsStore";
import { type TileCoordinates } from "@/types/tile";
import { FrameName } from "../entities/config";

export const getSettlementCastleFrameNameByLevel = (
	level: number,
): FrameName => {
	if (level > 70) return FrameName.SETTLEMENT_CASTLE_LEVEL10;
	if (level > 60) return FrameName.SETTLEMENT_CASTLE_LEVEL9;
	if (level > 50) return FrameName.SETTLEMENT_CASTLE_LEVEL8;
	if (level > 40) return FrameName.SETTLEMENT_CASTLE_LEVEL7;
	if (level > 30) return FrameName.SETTLEMENT_CASTLE_LEVEL6;
	if (level > 20) return FrameName.SETTLEMENT_CASTLE_LEVEL5;
	if (level > 15) return FrameName.SETTLEMENT_CASTLE_LEVEL4;
	if (level > 10) return FrameName.SETTLEMENT_CASTLE_LEVEL3;
	if (level > 5) return FrameName.SETTLEMENT_CASTLE_LEVEL2;
	return FrameName.SETTLEMENT_CASTLE_LEVEL1;
};

export const getSettlementCastleFrameNameByCoordinates = ({
	x,
	y,
}: TileCoordinates): FrameName => {
	// Toto musi byt v tejto funkcii, lebo inak este nie je initnute storko.
	const { getSettlementByCoordinates } = useSettlementsStore();

	const settlement = getSettlementByCoordinates({ x, y });
	if (!settlement?.level)
		throw new GameError(
			GameErrorType.SETTLEMENT_ERROR,
			`Settlement level not found for [${x}, ${y}]!`,
		);

	return getSettlementCastleFrameNameByLevel(settlement.level);
};

export const FRAME_NAME_LEVEL_REGEXP = /^(.+_lvl_)(\d+)(\.(?:png|webp|avif))$/i;

const PALISADE_MAX_LEVEL = 5;

export const getSettlementPalisadeFrameNameByCoordinates = ({
	x,
	y,
}: TileCoordinates): FrameName => {
	// Toto musi byt v tejto funkcii, lebo inak este nie je initnute storko.
	const { isValidSettlementByCoordinates, getSettlementByCoordinates } =
		useSettlementsStore();
	//TODO lazy init
	const tilerepo = useTileRepository();

	// get all tiles around and check if they are valid settlements
	for (let dy = -1; dy <= 1; dy++) {
		for (let dx = -1; dx <= 1; dx++) {
			if (dx === 0 && dy === 0) continue;

			const coordinates = { x: x + dx, y: y + dy };

			const isValid = isValidSettlementByCoordinates(coordinates);
			if (!isValid) continue;

			const settlement = getSettlementByCoordinates(coordinates);
			if (!settlement?.level)
				throw new GameError(
					GameErrorType.SETTLEMENT_ERROR,
					`Settlement level not found for [${x}, ${y}]!`,
				);

			const level = +getSettlementCastleFrameNameByLevel(
				settlement.level,
			).replace(FRAME_NAME_LEVEL_REGEXP, "$2");

			const [, tileId1, , tileId3] = tilerepo.getTileIdsByTileCoordinates(
				{ x, y },
			);
			const frameName =
				tilerepo.getFrameNameByTileId(tileId1 || tileId3) ??
				FrameName.NOT_SET;

			return frameName.replace(
				FRAME_NAME_LEVEL_REGEXP,
				`$1${Math.min(level, PALISADE_MAX_LEVEL)}$3`,
			) as FrameName;
		}
	}

	return FrameName.NOT_SET;
};
